<template>
    <div class="home">
        <Header />
        <div class="container">
            <h1 v-if="isWorkspaceOwner" style="margin-top: 50px; margin-bottom: 15px; font-size: 22px;">{{workspace.name}}</h1>
            <h1 v-else style="margin-top: 50px; margin-bottom: -28px; font-size: 22px;">{{workspace.name}}</h1>
                
            <div class="table-header" style="overflow: hidden;">

                <b-button v-if="isWorkspaceOwner" @click="workspaceSettingsModalOpen" type="is-default" style="float: left; font-size: 14px; margin-right: 10px">
                    <i class="fas fa-cogs"></i> Settings
                </b-button>
                <b-button v-if="isWorkspaceOwner" @click="inviteUserModalOpen" type="is-default" style="float: left; font-size: 14px;">
                    <i class="fas fa-users"></i> Invitations
                </b-button>
                <b-button v-if="!show_completed" @click="_getTasksCompleted" type="is-success" style="float: right; font-size: 14px;">
                    <i class="fas fa-check"></i> View completed
                </b-button>
                <b-button v-else @click="_getTasks" type="is-default" style="float: right; font-size: 14px;">
                    <i class="fas fa-bug"></i> View uncompleted
                </b-button>
            </div>

            <section id="table-tasks-list" style="padding-top: 15px;">
                <b-table
                    :data="tasks"
                    ref="table"
                    paginated
                    :bordered="true"
                    per-page="15"
                    detailed
                    detail-key="id"
                    :show-detail-icon="false"
                    aria-next-label="Next page"
                    aria-previous-label="Previous page"
                    aria-page-label="Page"
                    aria-current-label="Current page"
                    @select="selected"
                    :mobile-cards="false">

                    <template slot-scope="props">
                        <b-table-column field="name" label="Task" sortable>
                            {{ props.row.name }}
                        </b-table-column>
                        <b-table-column :field="getInitials(props.row.reporter.first_name + ' ' + props.row.reporter.last_name)" label="Reporter" width="40" sortable>
                            {{getInitials(props.row.reporter.first_name + " " + props.row.reporter.last_name)}}
                        </b-table-column>
                        <b-table-column field="created" label="Created" width="115" sortable>
                            {{props.row.created | moment("YYYY-MM-DD") }}
                        </b-table-column>
                        <b-table-column field="priority" label="Priority" width="40" numeric sortable>
                            <span v-if="props.row.priority == 0" class="label label-low">Low</span>
                            <span v-if="props.row.priority == 1" class="label label-warning">Medium</span>
                            <span v-if="props.row.priority == 2" class="label label-danger">High</span>
                        </b-table-column>
                        <b-table-column field="status" label="Status" width="40" numeric sortable>
                            <span v-if="props.row.status == 0" class="label label-pending">Pending</span>
                            <span v-if="props.row.status == 1" class="label label-primary">Started</span>
                            <span v-if="props.row.status == 2" class="label label-success">Completed</span>
                        </b-table-column>
                    </template>
                </b-table>
            </section>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import jwt_decode from 'jwt-decode'
import {getJWT, getHeaders, isEmptyList} from '../logic/global'
import {getInitials} from '../logic/account'
import {getWorkspace, updateWorkspace, createWorkspaceInvitation, cancelWorkspaceInvitation} from '../logic/workspace'
import {getTasks, getTasksCompleted} from '../logic/task'
import Header from '../components/Header'
import ModalCreateTask from '../components/ModalCreateTask'
import ModalInviteUser from '../components/ModalInviteUser'
import ModalWorkspaceSettings from '../components/ModalWorkspaceSettings'


let tasks = []
let show_completed = false;
let workspace = {}
let isWorkspaceOwner = false;

export default {
    name: 'WorkspaceSingle',
    components: {Header, ModalCreateTask},
    computed: mapGetters(["getWorkspaceId"]),
    data() {
        return {
            tasks: tasks,
            show_completed: show_completed,
            workspace: workspace,
            isWorkspaceOwner: isWorkspaceOwner
        }
    },
    methods: {
        isEmptyList: isEmptyList,
        getInitials: getInitials,
        selected: function(row){
            this.goToSingleTask(row.id)
        },
        goToSingleTask: function(task_id){
            this.$router.push({
                name: 'task_single',
                params: {
                    workspace_id: this.$route.params.workspace_id,
                    task_id: task_id
                }
            })
        },
        _getTasks: function(){
            getTasks(this.$route.params.workspace_id).then(response => {
                this.tasks = response.data.results;
                this.show_completed = false;
            }).catch(error => {
                this.showSuccessMsg("Something went wrong. Try again later or contact support.", "is-danger")
            })
        },
        _getWorkspace: function(){
            let token = jwt_decode(getJWT());
            getWorkspace(this.$route.params.workspace_id).then(response => {
                this.workspace = response.data
                if(this.workspace.owner == token["id"]){
                    this.isWorkspaceOwner = true;
                }
            });
        },
        inviteUserModalOpen: function(){
            let _this = this;
            _this.$modal.open({
                parent: this,
                component: ModalInviteUser,
                hasModalCard: true,
                props: {
                    workspace: this.workspace,
                },
                events: {
                    'created_invitation': created_invitation => {
                        createWorkspaceInvitation(this.workspace.id, created_invitation).then(response => {
                            _this._getWorkspace()
                            _this.refreshInvitationModal()
                        })
                    },
                    'cancel_invitation': cancel_invitation => {
                        cancelWorkspaceInvitation(this.workspace.id, cancel_invitation).then(response => {
                            _this._getWorkspace()
                            _this.refreshInvitationModal()
                        })
                    },
                    'member_deleted': member_deleted => {
                        _this._getWorkspace()
                        _this.refreshInvitationModal()
                    }
                }
            })
        },
        refreshInvitationModal: function(){
            getWorkspace(this.$route.params.workspace_id).then(response => {
                this.workspace = response.data
                this.inviteUserModalOpen()
            });
        },
        workspaceSettingsModalOpen: function(){
            let _this = this;
            _this.$modal.open({
                parent: this,
                component: ModalWorkspaceSettings,
                hasModalCard: true,
                props: {
                    workspace: this.workspace,
                },
                events: {
                    'workspace_saved': workspace_saved => {
                        updateWorkspace(this.$route.params.workspace_id, workspace_saved).then(response => {
                            console.log(response)
                            // window.location.reload();
                        })
                    }
                }
            })
        },
        showSuccessMsg: function(message, msg_type){
            this.$toast.open({message: message, type: msg_type})
        },
        _getTasksCompleted: function(){
            getTasksCompleted(this.$route.params.workspace_id).then(response => {
                this.tasks = response.data.results;
                this.show_completed = true;
            }).catch(error => {
                this.showSuccessMsg("Something went wrong. Try again later or contact support.", "is-danger")
            })
        }
    },
    mounted: function(){
       this._getTasks()
       this._getWorkspace()
    }
}
</script>

<style scoped>
    .table>tbody>tr>td, .table>tbody>tr>th, .table>tfoot>tr>td, .table>tfoot>tr>th, .table>thead>tr>td, .table>thead>tr>th {
        padding: 15px !important;
    }
    .table tr.task-row:hover td{
        background: #abd7f1;
        cursor: pointer;
    }
    #table-tasks-list >>> .b-table .table td,
    #table-tasks-list >>> .b-table .table th{
        border-width: 1px 1px 0px 0px !important;
    }
    #table-tasks-list >>> .table{
        border-left: 1px solid #dbdbdb;
        border-top: 1px solid #dbdbdb;
        border-bottom: 1px solid #dbdbdb;
    }
</style>
